import { Component, OnInit } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store, User, Withdrawal } from 'src/app/models/RestModels';
import { GetEmpty } from 'src/app/classes/Empties';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'app-print-withdrawal',
	templateUrl: './print-withdrawal.component.html',
	styleUrls: ['./print-withdrawal.component.css']
})
export class PrintWithdrawalComponent extends BaseComponent implements OnInit {
	withdrawal: Withdrawal | null = null;
	store: Store = GetEmpty.store();
	user: User = GetEmpty.user();
	is_print:boolean = false;

	ngOnInit(): void
	{
		this.subs.sink = this.route.paramMap
		.pipe
		(
			mergeMap((param_map)=>
			{
				let id =	param_map.get('withdrawal_id');
				this.setTitle('ReciboRetiro-'+id);
				this.is_print = param_map.has('print');
				return this.rest.withdrawal_info.get( id )
			}),
			mergeMap((response:any)=>
			{
				this.withdrawal = response?.withdrawal || response;
				let store_obs = response?.store ? of(response.store) : this.rest.store.get( this.withdrawal.store_id );
				let user_obs = response?.created_by_user
					? of(response.created_by_user)
					: (this.withdrawal.created_by_user_id ? this.rest.user.get( this.withdrawal.created_by_user_id ) : of(null));

				return forkJoin
				({
					store: store_obs,
					user: user_obs
				})
			})
		)
		.subscribe((response)=>
		{
			this.store = response.store;
			this.user = response.user;
			if( this.is_print )
			{
				window.addEventListener('afterprint', ()=>{
					window.close();
				})
				setTimeout(()=>{ window.print(); }, 300);
			}
		},(error)=>this.showError(error));
	}

	print()
	{
		window.print();
	}
}